export default "__VITE_ASSET__BJ0efd8Q__"